import { render } from "./UiText.vue?vue&type=template&id=2931759f&ts=true"
import script from "./UiText.vue?vue&type=script&lang=ts"
export * from "./UiText.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__